class jobs {
	/// Les propriétés privées
	#options = {
		method: 'GET',
		headers: {
			'Content-Type': 'application/json',
		}
	};
	#libelleSessionStorageAnnonces = 'annonces';
	#libelleSessionStoragePageCurrentJob = 'pageCurrentJob';
	#libelleSessionStorageNbPagesJob = 'nbPagesJob';

	constructor(config) {
		this.config = config;
		this.lightboxClasses = {
			bodyOpen: 'lightbox--open',
			placeholder: 'basicLightbox__placeholder'
		};
		this.nbAnnoncesParPage = this.config.nbAnnoncesParPage ?? 10;
		this.containerId = this.config.containerId ?? 'offres';
		this.paginationShowed = false;
		this.debug = this.config.debug ?? false;
	}

	/// Méthode appelée dans la view /esprit-terdav/recrutement
	initialize() {
		let self = this;
		// Appel des différentes méthodes lors du chargement de la page		
		this.getAnnonces();
		// On pagine ou on click pour afficher une annonce
		this.events(self);
	}

	/// On récupère le json des annonces et on populate grâce à <template data-template-clone="job" data-template-append-to="jobDetail"/>
	getAnnonces(page) {
		let self = this,
			tool = require('common/toolsPromise'),
			promiseTool = new tool(),
			url = new URL(this.config.url);

		// On vérifie que le nombre d'annonces par page === 10 
		// sinon on passe la valeur en paramètre de la requête
		if (this.nbAnnoncesParPage !== 10) {
			url.searchParams.set('rows', this.nbAnnoncesParPage);
		}

		// On vérifie que l'on n'a pas passé de numéro de page en paramètre
		if (Number.isInteger(page)) {
			url.searchParams.set('page', page);
			window.sessionStorage.setItem(this.#libelleSessionStoragePageCurrentJob, page);
		} else {
			window.sessionStorage.setItem(this.#libelleSessionStoragePageCurrentJob, 1);
		}

		// On fetch l'url
		let liste = promiseTool.getPromiseJson(url, this.#options)

		// On construit la liste des annonces en populant le <template>
		liste.then((response) => {
			this.config.moduleTemplate.then(() => {
				let cloneWar = require('modules/templateClone');

				this._utilitySetDatHumanReadable(response.jobs, 'creationDate');
				this._cleanHtml(response.jobs, 'descriptionMission')
				this._showAnnoncesUneFirst(response.jobs, 'frontPageAd')
				try {
					let templatingJobs = new cloneWar(document.querySelector('[data-template-job="listeAnnonces"]'), response);
					templatingJobs.initialize(response.jobs);
				} catch (e) {
					console.error(e)
				}
			})
			// On enregistre les datas
			this.saveDatas(response.jobs, this.#libelleSessionStorageAnnonces);
			this.saveDatas(this._getTotalPages(response.numFound), this.#libelleSessionStorageNbPagesJob);

			// On affiche la pagination
			if (response.numFound > this.nbAnnoncesParPage) {
				!this.paginationShowed && this.addPagination();
			}
			// Pas d'annonce, on vide le container
			else if (response.numFound === 0) {
				if (settingsApp.app === 'TDV') {
					document.getElementById(this.containerId).querySelector('.head').innerHTML = '';
				} else {
					document.getElementById(this.containerId).innerHTML = '';
				}
			}

			// Tools debug
			this.debug && console.table(response.jobs)
		})
	}

	/// Méthode de gestion des événements
	events(self) {
		document.querySelector('.recrutement').addEventListener('click', e => {
			const {
				target
			} = e;

			/// Si l'on clique sur le bouton "voir l'annonce"
			if (target.dataset.idJob != undefined) {
				e.preventDefault();
				target.dispatchEvent(
					new CustomEvent('showAnnonce', {
						bubbles: true,
						detail: {
							libelle: () => {
								return target.dataset.idJob
							}
						}
					})
				);
				// Pagination
			} else if (target.dataset.jobPagination) {
				self.pagination(self, target.dataset.jobPagination)
			}
		});

		/// On lance la popin Annonce ${idJob}
		document.querySelector('.recrutement').addEventListener('showAnnonce', (e) => {
			self.showAnnonce(e.detail.libelle())
		})
	}

	/// Méthode permettant l'affichage dans une popin de l'annonce ${id}
	showAnnonce(id) {
		let optionsLightbox = {
			className: `lightbox--job`,
			onShow: () => {
				document.body.classList.add(this.lightboxClasses.bodyOpen);
			},
			onClose: () => {
				document.body.classList.remove(this.lightboxClasses.bodyOpen);
			}
		};
		// On a importé le script 
		this.config.moduleLightBox.then(() => {
			let instance = require('modules/lib/basicLightbox.min');
			const templateInstance = instance.create(document.querySelector(`[data-template-job="annonce"]`), optionsLightbox);
			templateInstance.show();

			let cloneWar = require('modules/templateClone');
			// On filtre le json pour ne conserver que les données liées à l'annonce ${id}
			const annonce = JSON.parse(this.getDatas(this.#libelleSessionStorageAnnonces)).find(obj => {
				return obj.id === id;
			});
			this._utilitySetDatHumanReadable(annonce, 'creationDate')


			// On affiche l'annonce en populant le<template data-template="job">
			try {
				let templatingJob = new cloneWar(document.querySelector('[data-template-job="annonce"]'), annonce);
				document.querySelector('.basicLightbox__placeholder').innerHTML = templatingJob.interpolate(document.querySelector('[data-template-job="annonce"]').innerHTML, annonce);
			} catch (e) {
				console.error(e)
			}
		});
	}

	/// PAGINATION
	addPagination() {
		let html = document.querySelector('[data-template-job="pagination"]').innerHTML;
		document.getElementById('jobDetail').insertAdjacentHTML('afterend', html);
		this.paginationShowed = true;
	}

	pagination(self, operation) {
		let newPage = Number.parseInt(this.getDatas(this.#libelleSessionStoragePageCurrentJob))

		if (operation === '+') {
			newPage++;
		} else {
			newPage--;
		}

		// On scroll au début du container
		scroll({
			top: document.getElementById(this.containerId).offsetTop,
			behavior: "smooth"
		});

		// On vide le container et on ajoute le contenu de la nouvelle page
		document.getElementById('jobDetail').innerHTML = '';
		this.getAnnonces(newPage);

		// On met à jour l'affichage des <button> de pagination
		this._disabledButtonFirstOrLast();
	}

	/// GETTERS & SETTERS
	saveDatas(obj, name) {
		window.sessionStorage.setItem(name, JSON.stringify(obj));
	}

	getDatas(name) {
		return window.sessionStorage.getItem(name);
	}

	/// UTILITIES
	_showAnnoncesUneFirst(arr, bool) {
		arr.sort((a, b) => (a[bool] === b[bool]) ? 0 : (a[bool] ? -1 : 1));
	}
	_getTotalPages(nbAnnonces) {
		return Math.ceil(nbAnnonces / this.nbAnnoncesParPage);
	}
	_disabledButtonFirstOrLast() {
		// On est à la page n+1, on enabled <button> précédent
		if (this.getDatas(this.#libelleSessionStoragePageCurrentJob) > 1) {
			document.querySelector('[data-job-pagination="-"]').removeAttribute('disabled')
		} else {
			document.querySelector('[data-job-pagination="-"]').setAttribute('disabled', true)
		}

		// On est à la dernière page, on disabled <button> suivant
		if (this.getDatas(this.#libelleSessionStoragePageCurrentJob) === this.getDatas(this.#libelleSessionStorageNbPagesJob)) {
			document.querySelector('[data-job-pagination="+"]').setAttribute('disabled', true)
		} else {
			document.querySelector('[data-job-pagination="+"]').removeAttribute('disabled')
		}
	}

	/// TRAITEMENTS DES DONNÉES
	_cleanHtml(obj, props) {
		for (let item of obj) {
			var divElement = document.createElement('div');
			divElement.innerHTML = item[props];
			item[props] = divElement.innerText // on ne récupère que le text
		}
	}
	_utilitySetDatHumanReadable(obj, propertyName) {
		// On parcourt un array d'objets pour lesquels on met la date (`obj.propertyName`) au format JJ/MM/AAAA
		if (Array.isArray(obj)) {
			for (let item of obj) {
				item[propertyName] = new Intl.DateTimeFormat('fr-FR').format(new Date(item[propertyName]))
			}
		} else {
			obj[propertyName] = new Intl.DateTimeFormat('fr-FR').format(new Date(obj[propertyName]))
		}
	}
}